<template>
  <div class="min-h-screen bg-white flex flex-col">
    <!-- Navbar Header for Pusat Bantuan -->
    <header class="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div
        class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-18 sm:h-20 flex items-center justify-between"
      >
        <!-- Left: LAN RI Blue Logo & Pusat Bantuan Title -->
        <div class="flex items-center gap-3 sm:gap-6">
          <NuxtLink to="/revamp/pusat-bantuan" class="flex items-center">
            <img
              src="/images/lan-ri-blue-logo.png"
              alt="LAN RI Logo"
              class="h-8 sm:h-11 w-auto object-contain"
            />
          </NuxtLink>
          <span class="text-base sm:text-xl font-bold text-[#1E3A5F] tracking-tight">
            Pusat Bantuan
          </span>
        </div>

        <!-- Right: Action Buttons -->
        <div class="flex items-center gap-2 sm:gap-3">
          <NuxtLink
            to="/revamp"
            class="px-3 py-1.5 sm:px-5 sm:py-2.5 rounded-lg border border-slate-300 text-[#1F5085] hover:border-[#2663A3] hover:text-[#2663A3] text-xs sm:text-sm font-semibold transition bg-white shadow-xs inline-flex items-center justify-center text-center"
          >
            Kembali ke Beranda
          </NuxtLink>
          <NuxtLink
            to="/login"
            class="px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-lg bg-[#2663A3] hover:bg-[#1f5085] text-white text-xs sm:text-sm font-semibold transition shadow-xs inline-flex items-center justify-center text-center"
          >
            Masuk
          </NuxtLink>
        </div>
      </div>
    </header>

    <!-- Page Content Slot -->
    <main class="flex-1">
      <NuxtPage />
    </main>

    <!-- Footer -->
    <Footer  :is-dark-mode="true" />
  </div>
</template>

<script setup lang="ts">
import Footer from '~/components/revamp/Footer.vue';
</script>
